import React from 'react'

import styles from './index.module.css'

export type ButtonProps = {
  label: string
  onClick: () => void
  variant?: 'primary' | 'cancel' | 'danger'
  disabled?: boolean
  type?: 'button' | 'submit' | 'reset'
}

export const Button: React.FC<ButtonProps> = ({
  label,
  onClick,
  variant = 'primary',
  disabled = false,
  type = 'button',
}) => (
  <button
    className={`${styles.button} ${styles[variant]}`}
    onClick={onClick}
    disabled={disabled}
    type={type}
  >
    {label}
  </button>
)
